import * as __WEBPACK_EXTERNAL_MODULE__InputText_js_934eb478__ from "./InputText.js";
import * as __WEBPACK_EXTERNAL_MODULE__InputText_variants_js_7e897728__ from "./InputText.variants.js";
var __webpack_exports__InputText = __WEBPACK_EXTERNAL_MODULE__InputText_js_934eb478__.InputText;
var __webpack_exports__inputTextVariants = __WEBPACK_EXTERNAL_MODULE__InputText_variants_js_7e897728__.inputTextVariants;
export { __webpack_exports__InputText as InputText, __webpack_exports__inputTextVariants as inputTextVariants };
